export const createDefinedParams = (params = {}) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    const val = typeof value === 'string' ? value.trim() : value;
    const isBool = typeof val === 'boolean';
    const isArr = Array.isArray(val) && Boolean(val.length);
    const hasValue = Boolean(val) || isArr || isBool;

    if (hasValue) acc[key] = value;

    return acc;
  }, {});
